import BasicNode, { BasicNodeProps } from "./BasicNode";

const SkippedNode = (props: BasicNodeProps) => {
  return <BasicNode {...props} className="bg-slate-100" />;
};

export default SkippedNode;
